import React from "react";
import { Box, Typography } from "@mui/material";
import {
    tabsBarSx,
    tabItemSx,
    tabLabelSx,
    tabActiveIndicatorSx,
} from "../../../styles/cyberTheme";

export default function LeaderboardSelectionTabs({
    leaderboards,
    currentIndex,
    onSelect,
}) {
    return (
        <Box sx={tabsBarSx}>
            {leaderboards.map(({ label }, index) => {
                const isActive = index === currentIndex;
                const isLast = index === leaderboards.length - 1;
                return (
                    <Box
                        key={index}
                        onClick={() => onSelect(index)}
                        sx={tabItemSx(isActive, isLast)}
                    >
                        {isActive && <Box sx={tabActiveIndicatorSx} />}
                        <Typography sx={tabLabelSx(isActive)}>{label}</Typography>
                    </Box>
                );
            })}
        </Box>
    );
}